module.exports = __webpack_public_path__ + "img/Homepage-Robot.485d977b.svg";